"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_TYPE_ABBR = exports.PRODUCT_TYPES = exports.MIN_MASSACHUSETTS_AMT = exports.LC_PRODUCTS = exports.FIXED_RATE_PLANS = exports.DISCLOSURES = exports.ADS_PRODUCTS = void 0;
var MIN_MASSACHUSETTS_AMT = exports.MIN_MASSACHUSETTS_AMT = 6001;
var ADS_PRODUCTS = exports.ADS_PRODUCTS = ['IF', 'PRP'];
var LC_PRODUCTS = exports.LC_PRODUCTS = ['LCFRP', 'LCTNI'];
var PRODUCT_TYPES = exports.PRODUCT_TYPES = {
  PRP: 'PROMOTIONAL_RATE_PLAN',
  IL: 'INSTALLMENT_LOAN',
  IF: 'INTEREST_FREE_LOAN',
  LCFRP: 'LC_FIXED_RATE_PLAN',
  LCTNI: 'LC_TRUE_NO_INTEREST'
};
var PRODUCT_TYPE_ABBR = exports.PRODUCT_TYPE_ABBR = {
  PROMOTIONAL_RATE_PLAN: 'PRP',
  INSTALLMENT_LOAN: 'IL',
  INTEREST_FREE_LOAN: 'IF',
  LC_FIXED_RATE_PLAN: 'LCFRP',
  LC_TRUE_NO_INTEREST: 'LCTNI'
};
var FIXED_RATE_PLANS = exports.FIXED_RATE_PLANS = [PRODUCT_TYPE_ABBR.INSTALLMENT_LOAN, PRODUCT_TYPE_ABBR.LC_FIXED_RATE_PLAN, PRODUCT_TYPE_ABBR.LC_TRUE_NO_INTEREST];
var DISCLOSURES = exports.DISCLOSURES = {
  LC: {
    index: 1
  },
  IF: {
    index: 2,
    monthlyIndex: 1
  },
  PRP: {
    index: 4,
    monthlyIndex: 3
  },
  IL: {
    monthlyIndex: 2
  }
};
